import ItemVariation from 'src/models/item/ItemVariation'
import Model, { encoders, ID } from 'src/models/Model'
import ItemPackage from 'src/models/package/ItemPackage'
import TicketType from 'src/models/showing/TicketType'
export default class ItemPackageItem extends Model {
  static name = 'ItemPackageItem'

  static deletable = true
  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: true
      },

      ticketType: {
        type: TicketType,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      itemVariation: {
        type: ItemVariation,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      itemPackage: {
        type: ItemPackage,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      }
    }
  }
}
